import { baseApi } from "../../../../core/data/rtk/baseQuery";
import { ApiResponseType } from "../../../../core/data/rtk/apiResponseType";
import { CourseFeeSharePayloadType } from "../types/courseFeeShareRequest";
import {
  FeeShareResponseType,
  FeeShareApiResponse,
} from "../types/courseFeeShareResponse";

export const courseFeeShareApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllFeeShares: builder.query<
      FeeShareApiResponse,
      {
        size?: number;
        search?: string;
        page?: number;
        session_id?: number;
        course_id?: number;
        type_id?: number;
        share_type?: string;
      }
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.size) queryParams.append("size", params.size.toString());
        if (params?.search) queryParams.append("search", params.search);
        if (params?.page) queryParams.append("page", params.page.toString());
        if (params?.session_id)
          queryParams.append("session_id", params.session_id.toString());
        if (params?.course_id)
          queryParams.append("course_id", params.course_id.toString());
        if (params?.type_id)
          queryParams.append("type_id", params.type_id.toString());
        if (params?.share_type)
          queryParams.append("share_type", params.share_type);

        return `course-fee-share/get-all?${queryParams.toString()}`;
      },
      providesTags: ["CourseFeeShare"],
    }),
    addFeeShare: builder.mutation<
      ApiResponseType<{ feeShare: FeeShareResponseType }>,
      CourseFeeSharePayloadType
    >({
      query: (payload) => ({
        url: "course-fee-share/save",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: ["CourseFeeShare", "Centers"],
    }),
    getFeeShareById: builder.query<
      ApiResponseType<{
        feeShare?: FeeShareResponseType;
        coursefeeshare?: FeeShareResponseType;
      }>,
      { id: string }
    >({
      query: ({ id }) => `course-fee-share/get/${id}`,
      providesTags: ["CourseFeeShare"],
    }),
    updateFeeShare: builder.mutation<
      ApiResponseType<{ feeShare: FeeShareResponseType }>,
      { id: string; payload: CourseFeeSharePayloadType }
    >({
      query: ({ id, payload }) => ({
        url: `course-fee-share/update/${id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: ["CourseFeeShare", "Centers"],
    }),
    deleteFeeShare: builder.mutation<
      ApiResponseType<{ deleted: true }>,
      { id: string }
    >({
      query: ({ id }) => ({
        url: `course-fee-share/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CourseFeeShare", "Centers"],
    }),
  }),
});

export const {
  useGetAllFeeSharesQuery,
  useAddFeeShareMutation,
  useGetFeeShareByIdQuery,
  useUpdateFeeShareMutation,
  useDeleteFeeShareMutation,
} = courseFeeShareApi;
